export default {
  getActiveBlockchain: state => state.activeBlockchain,
  getRangeFilter: state => state.rangeFilter,
  getRiskFilter: state => state.riskFilter,
  getSourceFilter: state => state.sourceFilter,
}